import { AbstractControl } from '@angular/forms';

export interface ControlErrorVisibilityOptions {
  submitAttempted?: boolean;
}

export function shouldShowControlError(
  control: AbstractControl | null,
  options: ControlErrorVisibilityOptions = {}
): boolean {
  return !!control && control.invalid && (control.touched || options.submitAttempted === true);
}
